import { httpClient } from './httpClient';

export const exportApi = {
  leads: (): Promise<void> => httpClient.download('/api/v1/leads/export.xlsx', `leads-${new Date().toISOString().slice(0, 10)}.xlsx`),
  contacts: (): Promise<void> => httpClient.download('/api/v1/contacts/export.xlsx', `contacts-${new Date().toISOString().slice(0, 10)}.xlsx`),
  accounts: (): Promise<void> => httpClient.download('/api/v1/accounts/export.xlsx', `customers-${new Date().toISOString().slice(0, 10)}.xlsx`),
};
